import useSWRImmutable from "swr/immutable";
import {
    getAnaerobicThresholdGraphs,
    getAnaerobicThresholdTablesData,
} from "../api/anaerobic-threshold";
import { VATValues } from "../api/types";
import { TestGraph } from "../types";
import useGraphsFactory from "./useGraphsFactory";
import useTestId from "./useTestId";

export function useAnaerobicGraphs({ enabled = true }: { enabled?: boolean }) {
    const testId = useTestId();

    // Create a unique key for the SWR cache
    const swrKey =
        testId && enabled
            ? `graphs:anaerobic-threshold-${JSON.stringify({
                  testId,
              })}`
            : null;

    const fetcher = async () => {
        if (!testId) {
            throw new Error("Test ID is required");
        }
        return (await getAnaerobicThresholdGraphs({
            testId,
        })) as TestGraph[];
    };

    return useGraphsFactory(fetcher, swrKey);
}

export function useAnaerobicTablesData() {
    const testId = useTestId();

    // Create a unique key for the SWR cache
    const swrKey = testId
        ? JSON.stringify({
              endpoint: "anaerobic-threshold-tables",
              testId,
          })
        : null;

    const fetcher = async () => {
        if (!testId) {
            throw new Error("Test ID is required");
        }
        return (await getAnaerobicThresholdTablesData({
            testId,
        })) as VATValues;
    };

    const { data, error, mutate, isLoading } = useSWRImmutable<VATValues>(
        swrKey,
        fetcher
    );

    return {
        value: data,
        loading: isLoading,
        error,
        refetch: mutate,
    };
}
